import React from 'react';
import {Container, Row, Col, Image} from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import ReviewVideo from './ReviewVideo';

const GoogleReview = () => {


   const location = useLocation();
  // console.log('sinnamuthu',location.pathname);
  return (
    <section className="sp-cnt-blk">
      <Container>
        <div className='sp-cnt-in text-center'>
          <div className='sp-cnt-in2 no-package gr'>            
            <div class="vertical-badge lft">
              <span>We Accept Digital Payments Only</span>
            </div>       
            <div class="vertical-badge rt">
              <span>We Accept Cashless  Payments Only</span>
            </div>
          <div className='hdg'><figure><Image src={`${process.env.PUBLIC_URL}/images/google-review-hdg.png`} fluid /></figure></div>
          <Row className='mb20 justify-content-center align-items-center'>  
            <Col xs={11} sm={8} lg={8}>
                 <ReviewVideo videoId="R-W0dp4qbMs" />   
             </Col>  
          </Row>            
          <Row>
            <div className="contact-wrap">
              <div className='whatsapp-blk'>
                <p>For more updates please</p>
                <div className='btn-whatsapp'><a href='https://wa.me/9884334346' target='_blank'><Image src={`${process.env.PUBLIC_URL}/images/ic-whatsapp.png`} fluid /> 9884334346</a></div>
              </div>
            </div>
          </Row>
          </div>
        </div>
      </Container>
    </section>      
  )
}

export default GoogleReview